export default __webpack_public_path__ + "f0d59097ba87333776c53307d06b0d79.svg";